import React from 'react';
import './JobListings.scss';

const JobListings = () => {
  const jobs = [
    {
      id: 1,
      title: 'Pro League Clinic',
      time: '12:30PM - 4:30PM',
      sport: 'Lacrosse',
      location: '7 miles away',
      price: '$60hr',
    },
    {
      id: 2,
      title: 'Bay Clash',
      time: '12:30PM - 4:30PM',
      sport: 'Wrestling',
      location: '12 miles away',
      price: '$60hr',
    },
    {
      id: 3,
      title: 'College Showcase',
      time: '12:30PM - 4:30PM',
      sport: 'Field Hockey',
      location: '21 miles away',
      price: '$60hr',
    },
    {
      id: 4,
      title: 'HSAA Tournament',
      time: '12:30PM - 4:30PM',
      sport: 'Basketball',
      location: '30 miles away',
      price: '$60hr',
    },
  ];

  return (
    <div className="jobListings">
      {jobs.map(job => (
        <div key={job.id} className="jobListings-card">
          <div className="jobListings-header">
            <h3 className="jobListings-title">{job.title}</h3>
            <div className="jobListings-price">{job.price}</div>
          </div>
          <div className="jobListings-bottom">
            <div className="jobListings-details">
              <div className="jobListings-time">{job.time}</div>
              <div className="jobListings-sport">{job.sport}</div>
              <div className="jobListings-location">{job.location}</div>
            </div>
            <button className="jobListings-apply-button">APPLY</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default JobListings;
